import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { http_get, http_post } from "../../utils/api_client";
import { API_ENDPOINTS } from "../../utils/endpoints";

const STATUS_CLASS = { Stuck: "stuck", "At risk": "risk", "Not engaged": "dis", Neutral: "neu" };
const AV_COLORS = ["#C0407A", "#3B7DD8", "#5B54C0", "#8452C0", "#3AA6A0", "#E8843C", "#0FA3B8"];

function initials(n) {
  if (!n) return "?";
  const p = n.trim().split(/\s+/).filter(Boolean);
  if (p.length === 0) return "?";
  return (p.length === 1 ? p[0].slice(0, 2) : p[0][0] + p[p.length - 1][0]).toUpperCase();
}
function colorFor(s) {
  let h = 0;
  for (let i = 0; i < (s || "").length; i += 1) h = (h * 31 + s.charCodeAt(i)) % AV_COLORS.length;
  return AV_COLORS[Math.abs(h)];
}

function NeedsAttention() {
  const { companySlug } = useParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState({});

  useEffect(() => {
    let alive = true;
    http_get(API_ENDPOINTS.GET_DASHBOARD_NEEDS_ATTENTION)
      .then(({ data }) => { if (alive) setRows(data || []); })
      .catch(() => { if (alive) setRows([]); });
    return () => { alive = false; };
  }, []);

  const nudge = async (r) => {
    if (!r.nudge) { toast.info("No active step to nudge for this learner."); return; }
    setBusy((b) => ({ ...b, [r.id]: true }));
    try {
      await http_post(API_ENDPOINTS.SEND_PATH_NUDGE(r.id, r.nudge.learning_material_id), { step_uid: r.nudge.step_uid });
      toast.success(`Nudge sent to ${r.learner.name}.`);
    } catch (e) {
      toast.error(e?.response?.data?.error || "Could not send nudge.");
    } finally {
      setBusy((b) => ({ ...b, [r.id]: false }));
    }
  };

  return (
    <div className="dv-card dv-attention">
      <div className="dv-head">
        <div className="dv-attn-title"><h3>Needs attention</h3>{rows && rows.length > 0 && <span className="dv-count">{rows.length}</span>}</div>
        <div className="sp" />
      </div>
      {!rows ? (
        <div className="dv-empty">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="dv-empty-state">
          <span className="dv-empty-state__ic dv-empty-state__ic--ok">✓</span>
          <div className="dv-empty-state__t">You&rsquo;re all caught up</div>
          <div className="dv-empty-state__s">No learners need attention right now. Stuck and at-risk learners will appear here so you can step in.</div>
        </div>
      ) : (
      <>
      <div className="dv-sub" style={{ marginTop: -8, marginBottom: 10 }}>
        Learners stuck or trending at-risk — sorted by lowest engagement. Intervene on the bottom few.
      </div>
      {rows.map((r) => {
        const cls = STATUS_CLASS[r.status] || "neu";
        const scoreCls = r.engagementScore == null ? "" : (r.engagementScore < 40 ? "lo" : (r.engagementScore < 60 ? "mid" : ""));
        const ctx = r.context;
        return (
          <div className="dv-lrow" key={r.id}>
            <div className="dv-who">
              <span className="dv-av" style={{ background: colorFor(r.learner.name) }}>{initials(r.learner.name)}</span>
              <div><div className="dv-nm">{r.learner.name}</div><div className="dv-cx">{r.learner.email || "no email"}</div></div>
            </div>
            <div className="dv-step">{ctx}</div>
            <span className={`dv-status dv-status--${cls}`}><span className="dv-dot" />{r.status}</span>
            <div className={`dv-score ${scoreCls}`}>{r.engagementScore}</div>
            <div className="dv-acts">
              <button type="button" className="dv-btn dv-btn--primary" disabled={!r.nudge || busy[r.id]} onClick={() => nudge(r)}>
                {busy[r.id] ? "Sending…" : "Nudge"}
              </button>
              <button type="button" className="dv-btn" onClick={() => navigate(`/${companySlug}/audience/${r.id}`)}>View</button>
            </div>
          </div>
        );
      })}
      </>
      )}
    </div>
  );
}

export default NeedsAttention;
